import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsNewsResponse } from "../../Orchestrator/Types/Interface/ICMSNews";

export async function getCmsNewsList(): Promise<
  IApiResponse<ICmsNewsResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsNewsAPI;

  const params = new URLSearchParams({
    "populate": "*",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsNewsResponse>(endpointWithParams, "GET");
}


export async function getCmsNewsDetail(slug: string): Promise<
  IApiResponse<ICmsNewsResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsNewsAPI;

  const params = new URLSearchParams({
    "populate": "*",
    "filters[slug][$eq]": slug,
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsNewsResponse>(endpointWithParams, "GET");
}
